import React from "react";

export interface ThreeCirclesProps {
  width?: number;
  height?: number;
  color?: string;
}

const ThreeCircles: React.FC<ThreeCirclesProps> = ({ width = 355, height = 356, color = "#868697" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 355 356" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_15781_119)">
        <mask id="path-1-inside-1_15781_119" fill="white">
          <path d="M0 43.3086C0 -129.28 139.911 -269.191 312.5 -269.191V-269.191C485.089 -269.191 625 -129.28 625 43.3086V43.3086C625 215.898 485.089 355.809 312.5 355.809V355.809C139.911 355.809 0 215.898 0 43.3086V43.3086Z" />
        </mask>
        <path
          d="M0 43.3086M625 43.3086M625 43.3086M0 43.3086M312.5 -269.191M625 43.3086M312.5 355.809M0 43.3086M312.5 355.809V354.809C140.463 354.809 1 215.345 1 43.3086H0H-1C-1 216.45 139.359 356.809 312.5 356.809V355.809ZM625 43.3086H624C624 215.345 484.537 354.809 312.5 354.809V355.809V356.809C485.641 356.809 626 216.45 626 43.3086H625ZM312.5 -269.191V-268.191C484.537 -268.191 624 -128.728 624 43.3086H625H626C626 -129.833 485.641 -270.191 312.5 -270.191V-269.191ZM312.5 -269.191V-270.191C139.359 -270.191 -1 -129.833 -1 43.3086H0H1C1 -128.728 140.463 -268.191 312.5 -268.191V-269.191Z"
          fill="#6C48F0"
          mask="url(#path-1-inside-1_15781_119)"
        />
        <mask id="path-3-inside-2_15781_119" fill="white">
          <path d="M105 43.8086C105 -70.7905 197.901 -164.191 312.5 -164.191V-164.191C427.099 -164.191 520 -70.7905 520 43.8086V43.8086C520 158.408 427.099 251.809 312.5 251.809V251.809C197.901 251.809 105 158.408 105 43.8086V43.8086Z" />
        </mask>
        <path
          d="M105 43.8086M520 43.8086M520 43.8086M105 43.8086M312.5 -164.191M520 43.8086M312.5 251.809M105 43.8086M312.5 251.809V250.809C198.456 250.809 106 157.859 106 43.8086H105H104C104 158.957 197.346 252.809 312.5 252.809V251.809ZM520 43.8086H519C519 157.859 426.544 250.809 312.5 250.809V251.809V252.809C427.655 252.809 521 158.957 521 43.8086H520ZM312.5 -164.191V-163.191C426.544 -163.191 519 -70.2413 519 43.8086H520H521C521 -71.3396 427.655 -165.191 312.5 -165.191V-164.191ZM312.5 -164.191V-165.191C197.346 -165.191 104 -71.3396 104 43.8086H105H106C106 -70.2413 198.456 -163.191 312.5 -163.191V-164.191Z"
          fill="#6C48F0"
          mask="url(#path-3-inside-2_15781_119)"
        />
        <mask id="path-5-inside-3_15781_119" fill="white">
          <path d="M216 43.8086C216 -9.48688 259.205 -53.1914 312.5 -53.1914V-53.1914C365.795 -53.1914 409 -9.48688 409 43.8086V43.8086C409 97.1041 365.795 140.809 312.5 140.809V140.809C259.205 140.809 216 97.1041 216 43.8086V43.8086Z" />
        </mask>
        <path
          d="M216 43.8086M409 43.8086M409 43.8086M216 43.8086M312.5 -53.1914M409 43.8086M312.5 140.809M216 43.8086M312.5 140.809V139.809C259.764 139.809 217 96.5585 217 43.8086H216H215C215 97.6496 258.646 141.809 312.5 141.809V140.809ZM409 43.8086H408C408 96.5585 365.236 139.809 312.5 139.809V140.809V141.809C366.354 141.809 410 97.6496 410 43.8086H409ZM312.5 -53.1914V-52.1914C365.236 -52.1914 408 -8.94133 408 43.8086H409H410C410 -10.0324 366.354 -54.1914 312.5 -54.1914V-53.1914ZM312.5 -53.1914V-54.1914C258.646 -54.1914 215 -10.0324 215 43.8086H216H217C217 -8.94133 259.764 -52.1914 312.5 -52.1914V-53.1914Z"
          fill="#6C48F0"
          mask="url(#path-5-inside-3_15781_119)"
        />
      </g>
      <defs>
        <clipPath id="clip0_15781_119">
          <rect width="355" height="356" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ThreeCircles;
